module.exports = __webpack_public_path__ + "img/test_01.dfc9027f.jpg";